import Vue from 'vue';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

import 'vue-select/dist/vue-select.css';
import '../scss/vue-select.scss';